<template>
    <BarChartGenerator v-if="show" :chart-options="chartOptions" :chart-data="{ labels, datasets }" :chart-id="chartId"
        :dataset-id-key="datasetIdKey" :css-classes="cssClasses" :styles="styles" :width="width" :height="height" />
</template>
<script>
import { Bar as BarChartGenerator } from 'vue-chartjs/legacy'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    LinearScale,
    CategoryScale
} from 'chart.js'
ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    LinearScale,
    CategoryScale
)
export default {
    name: 'BarChart',
    components: {
        BarChartGenerator
    },
    props: {
        datasets: {
            type: Array,
            default: () => []
        },
        labels: {
            type: Array,
            default: () => []
        },
        chartId: {
            type: String,
            default: 'bar-chart'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => { }
        },
        plugins: {
            type: Array,
            default: () => []
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        show: {
            type: Boolean,
            default: true
        },
        // When provided, these options are used verbatim instead of the
        // built-in defaults. Lets callers enable the legend / custom tooltips
        // (e.g. the day-of-week comparison) without affecting existing usages.
        options: {
            type: Object,
            default: null
        }
    },
    computed: {
        chartOptions() {
            if (this.options) {
                return this.options
            }
            return {
                indexAxis: this.horizontal ? 'y' : 'x',
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    }
                }
            }
        }
    }
}
</script>
